export default __webpack_public_path__ + "static/media/vault.fd65c649.webp";